module.exports = __webpack_public_path__ + "img/totalPayrollBackground.b328a71f.svg";